import React, { useState, useMemo } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { FilterProvider } from './context/FilterContext';
import { GlobalConfigProvider } from './context/GlobalConfigProvider';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { DrawerProvider } from './context/DrawerContext';

import { inputsCustomizations } from './theme/customizations/inputs';
import { dataDisplayCustomizations } from './theme/customizations/dataDisplay';
import { colorSchemes, typography, shadows, shape } from './theme/themePrimitives';

const Root = () => {
  // Leer el estado inicial desde localStorage
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem('isDarkMode');
    return savedTheme === 'true'; // Convertir a booleano
  });

  const toggleTheme = () => {
    const newTheme = !isDarkMode;
    setIsDarkMode(newTheme);
    localStorage.setItem('isDarkMode', newTheme); // Guardar en localStorage
  };

  const theme = useMemo(() => {
    const baseTheme = createTheme({
      palette: {
        mode: isDarkMode ? 'dark' : 'light',
        ...(isDarkMode ? colorSchemes.dark.palette : colorSchemes.light.palette), // Acceder al esquema correcto
      },
      typography,
      shape,
      shadows: isDarkMode ? shadows.dark : shadows.light,
      components: {
        ...inputsCustomizations,
        ...dataDisplayCustomizations,
      },
    });

    return baseTheme;
  }, [isDarkMode]);

  // Registrar el Service Worker para manejar notificaciones en segundo plano
  // Registrar el Service Worker para manejar notificaciones en segundo plano
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .then((registration) => {
        if (process.env.NODE_ENV === 'development') {
          console.log('Service Worker registrado:', registration);
        }
      })
      .catch((error) => {
        console.error('Error al registrar el Service Worker:', error);
      });
  }
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <GlobalConfigProvider>
          <FilterProvider>
            <DrawerProvider>
              <App toggleTheme={toggleTheme} isDarkMode={isDarkMode} />
            </DrawerProvider>
          </FilterProvider>
        </GlobalConfigProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
